export const SL_VERSION = "1.6.1";
export const SL_IS_DEMO = false;